import { useAsync } from '@arcxmoney/arcx-react'
import React, { useContext } from 'react'
import { ArcContext } from '../../contexts/ArcContext'
import { useServices } from '../../contexts/ServicesContext'
import { Spinner } from '../Spinner'
import { Title } from '../Title'
import { CategoryHeader } from './CategoryHeader/CategoryHeader'
import './LevelDashboard.scss'
import { SkillItem } from './SkillItem/SkillItem'

interface IProps {
  account: string
}

export function LevelDashboard({ account }: IProps) {
  const { arcxApi } = useServices()
  const { services } = useContext(ArcContext)
  const [questSkillSet] = useAsync(() => services.productQuests.getProductQuestsSkillSet(), [])

  const [groups] = useAsync(async () => {
    if (!account) {
      return
    }
    const [combat, artisan, gathering, support] = await Promise.all([
      arcxApi.getSkillSetsFor(account, 'combat'),
      arcxApi.getSkillSetsFor(account, 'artisan'),
      arcxApi.getSkillSetsFor(account, 'gathering'),
      arcxApi.getSkillSetsFor(account, 'support'),
    ])
    return { combat, artisan, gathering, support }
  }, [account])

  if (!groups || !questSkillSet) {
    return (
      <>
        <Title
          title={'Level'}
          className="level-dashboard__title"
          description={
            <>
              Contribute to ARCx by helping the network and participating in the community to earn
              XP tokens and level up.{' '}
              <a target="_blank" rel="noreferrer" href="https://discord.gg/skwz6je">
                Jump into the Discord to get started.
              </a>
            </>
          }
        />
        <Spinner />
      </>
    )
  }

  const { combat, artisan, gathering, support } = groups

  const combatLevel = combat.value * combat.multiplier
  const artisanLevel = artisan.value * artisan.multiplier
  // const gatheringLevel = (gathering.value + questSkillSet.value) * gathering.multiplier;
  const gatheringLevel = gathering.value * gathering.multiplier
  const supportLevel = support.value * support.multiplier
  const level = combatLevel + artisanLevel + gatheringLevel + supportLevel

  return (
    <>
      <Title
        title={`Level ${level}`}
        className="level-dashboard__title"
        description={
          <>
            Contribute to ARCx by helping the network and participating in the community to earn XP
            tokens and level up.{' '}
            <a target="_blank" rel="noreferrer" href="https://discord.gg/skwz6je">
              Jump into the Discord to get started.
            </a>
          </>
        }
      />
      <div className="level-dashboard">
        <div className="level-dashboard__level-item">
          <CategoryHeader
            title="Combat"
            icon="sword"
            level={combatLevel}
            linearGradient="linear-gradient(90deg, #9C9AF9 0%, #904E95 100%)"
          />
          {combat.skillSets.map((skill) => (
            <SkillItem
              key={skill.name}
              subtitle={skill.name}
              xp={skill.value}
              icon={skill.icon}
              description={skill.description}
            />
          ))}
        </div>
        <div className="level-dashboard__level-item">
          <CategoryHeader
            title="Artisan"
            icon="mana"
            level={artisanLevel}
            linearGradient="linear-gradient(90deg, #965090 0%, #DE6161 100%)"
          />
          {artisan.skillSets.map((skill) => (
            <SkillItem
              key={skill.name}
              subtitle={skill.name}
              xp={skill.value}
              icon={skill.icon}
              description={skill.description}
            />
          ))}
          {/* <SkillItem
            subtitle='Developer Quests'
            xp={1}
            icon='arrows'
          /> */}
        </div>
        <div className="level-dashboard__level-item">
          <CategoryHeader
            title="Gathering"
            icon="crystal"
            level={gatheringLevel}
            linearGradient="linear-gradient(90deg, #DE6161 0%, #2657EB 100%)"
          />
          {gathering.skillSets.map((skill) => (
            <SkillItem
              key={skill.name}
              subtitle={skill.name}
              xp={skill.value}
              icon={skill.icon}
              description={skill.description}
            />
          ))}
          {/* <SkillItem
            subtitle={questSkillSet.name}
            xp={questSkillSet.value}
            icon={questSkillSet.icon}
          /> */}
        </div>
        <div className="level-dashboard__level-item">
          <CategoryHeader
            title="Support"
            icon="heart"
            level={supportLevel}
            linearGradient="linear-gradient(90deg, #5433FF 0%, #20BDFF 50%, #A5FECB 100%)"
          />
          {support.skillSets.map((skill) => (
            <SkillItem
              key={skill.name}
              subtitle={skill.name}
              xp={skill.value}
              icon={skill.icon}
              description={skill.description}
            />
          ))}
          {/* <SkillItem
            subtitle='Introduction Discord'
            xp={1}
            icon='discord'
          /> */}
        </div>
      </div>
      {/* <ProductQuests quests={questSkillSet.quests} /> */}
    </>
  )
}
